(($) => {
    if (window.innerWidth < 1300) {
        const toogleBtn = $('#toggleDataTable');

        toogleBtn.on('click', function() {
            $(this).toggleClass('active');
            // add height to the table and increase opacity to 1
            $('.toggleDataTable__table').toggleClass('active');
        });
    }
})(jQuery);